import { Component, OnInit } from '@angular/core';
import { translationHelper } from '~/helpers/translation.helper';
import { uiHelper } from '~/helpers/ui.helper';
import { CoreService } from '~/legacy/ts/services/core.service';
import { IAngularMyDpOptions, IMyDateModel } from 'angular-mydatepicker';
import { TournamentsService } from '~/legacy/ts/tournaments/services/tournaments.service';

declare let $;

@Component({
    selector: 'adminMenu',
    templateUrl: './admin.menu.component.html',
})
export class AdminMenuComponent {
    isPasswordNotEntered = true;

    selectedItem = { b: 'non', s: 'non' };

    menuData = [
        {
            text: 'Bilanço',
            id: 'bilanco',
            subMenus: [
                {
                    text: 'Para Çekme',
                    id: 'parac',
                },
                {
                    text: 'Günlük Rapor',
                    id: 'grapor',
                },
                {
                    text: 'Aylık Rapor',
                    id: 'arapor',
                },
                {
                    text: 'Bayi Bilançosu',
                    id: 'bayibilanc',
                },
            ],
        },
        {
            text: 'Ödeme',
            id: 'odeme',
            subMenus: [
                {
                    text: 'Alacak Makbuzu',
                    id: 'bkupon',
                },
            ],
        },
        {
            text: 'Yönetim',
            id: 'yonetim',
            subMenus: [
                {
                    text: 'Bahis kuponu kopyası',
                    id: 'bkuponu',
                },
            ],
        },
        {
            text: 'Çıkış',
            id: 'cikis',
            subMenus: [
                {
                    text: 'Çıkış',
                    id: 'c',
                },
            ],
        },
    ];

    bkupon_error = '';
    bkuponu_error = '';

    myDpOptions: IAngularMyDpOptions = {
        inline: true,
        dateRange: false,
        dateFormat: 'dd.mm.yyyy',
        defaultView: 2,
        monthSelector: true,
        // other options are here...
    };

    langCode = 'en';

    dateModel_daily: IMyDateModel = null;
    dateModel_monthly: IMyDateModel = null;
    dateModel_monthly_MY = null;
    dateModel_monthly_Select = true;
    dateModel_monthly_isInitial = true;

    getPrintLastSlipByParameter_data = [0, 0];

    constructor(
        public coreService: CoreService,
        private _translationHelper: translationHelper,
        public _uiHelper: uiHelper,
        private tournamentsService: TournamentsService,
    ) {
        this.langCode = this._translationHelper.LANGCODE;
    }

    onMenuItemClick(b, s) {
        if (b === 'cikis') {
            this._uiHelper.setAdminScreen(false, 0);
        }

        this.selectedItem = {
            b: b,
            s: s,
        };
    }

    onDateChanged(event: IMyDateModel): void {
        console.log('Date selected: ', event);
    }

    onCalendarView(event): void {
        console.log('view', event);

        this.dateModel_monthly_MY = new Date(event.year, event.month);

        if (!this.dateModel_monthly_isInitial) {
            console.log(false);
            this.dateModel_monthly_Select = false;
        }

        this.dateModel_monthly_isInitial = false;
    }

    onChangeSelectStatsMonth(): void {
        this.dateModel_monthly_isInitial = true;
        this.dateModel_monthly_Select = true;
    }

    public PrintLastSlip() {
        this.tournamentsService.getPrintLastSlip();
    }

    public getPrintLastSlipByParameter(slipID?) {
        console.log(slipID);

        if (!slipID && this.getPrintLastSlipByParameter_data[0] != 0) {
            this.tournamentsService.getPrintLastSlipByParameter(
                this.getPrintLastSlipByParameter_data[0],
                this.getPrintLastSlipByParameter_data[1],
            );
        } else if (slipID) {
            this.tournamentsService.getPrintLastSlipByParameter(slipID[0], slipID[1]).then(x => {
                if (x == 'fail') {
                    this.bkuponu_error = 'Kupon bilgilerini kontrol edip tekrar deneyiniz.';
                } else {
                    this.bkuponu_error = '';
                }
            });
        }
    }

    onPayoutSlipPay(slipNo, slipPass) {
        this.tournamentsService.PayoutSlipNumber = slipNo;
        this.tournamentsService.PayoutSlipPassword = slipPass;
        this.tournamentsService.payoutPayConfirmButton = 1;
        this.tournamentsService.payoutSlipPay($('input[name="__RequestVerificationToken"]').val()).then(res => {
            if (res == '') {
                this.bkupon_error = '';
            } else {
                this.bkupon_error = res;
            }
        });
    }

    passwordCheck(e): void {
        if (e == '') {
            this._uiHelper.setAdminScreen(false, 0);
        } else {
            this._uiHelper.setAdminScreen(true, 2);
            this.isPasswordNotEntered = false;
        }
    }

    public Open_Payout_Modal() {
        this.coreService.configureClient();
        if (this.coreService.customerUser.TerminalBalance != '0.00') {
            $('#PayoutModal')
                .modal({
                    detachable: false,
                })
                .modal('show');
        }
    }
}
